module.exports = __webpack_public_path__ + "img/tree-03-g-trunk.a5913c15.png";